import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { TableArea } from '../assets/interfaces/waiter_interfaces';

const AREA_STORAGE_KEY = 'selected_waiter_area';

interface AreaPropsData {
  selectedArea: TableArea | null;
  setSelectedArea: (area: TableArea | null) => void;
}

const AreaContext = createContext<AreaPropsData | undefined>(undefined);

export const useArea = () => {
  const context = useContext(AreaContext);
  if (context === undefined) {
    throw new Error('useArea must be used within an AreaProvider');
  }
  return context;
};

interface AreaProviderProps {
  children: ReactNode;
}

export const AreaProvider: React.FC<AreaProviderProps> = ({ children }) => {
  const [selectedArea, setSelectedArea] = useState<TableArea | null>(() => {
    const storedArea = localStorage.getItem(AREA_STORAGE_KEY);
    if (!storedArea) {
      return null;
    }

    try {
      return JSON.parse(storedArea) as TableArea;
    } catch {
      localStorage.removeItem(AREA_STORAGE_KEY);
      return null;
    }
  });

  useEffect(() => {
    if (selectedArea) {
      localStorage.setItem(AREA_STORAGE_KEY, JSON.stringify(selectedArea));
      return;
    }

    localStorage.removeItem(AREA_STORAGE_KEY);
  }, [selectedArea]);

  return (
    <AreaContext.Provider value={{ selectedArea, setSelectedArea }}>
      {children}
    </AreaContext.Provider>
  );
};
